export const SAVE_GAINS = 'SAVE_GAINS'

export const saveGains = (data) => ({
    type: SAVE_GAINS,
    data
})